import { IMember } from 'affiny-core/modules/members/types';
import { IRootState } from 'affiny-core/modules/state';
import get from 'lodash/get';
import { createSelector } from 'reselect';

/* ***** *****  Global member selector  ***** ***** */

export const selectMember = () =>
  createSelector(
    [
      (state: IRootState) => state.members,
      (state: IRootState, accountId: string) => accountId,
    ],
    (members, id): IMember | undefined => members.entries[id]
  );

/* ***** *****  Attributes selector  ***** ***** */

export const selectMemberAttribute = (
  state: IRootState,
  id: IMember['id'],
  attribute: string
) => {
  const member = selectMember()(state, id);

  return get(member, `attributes.${attribute}`);
};

export const selectMemberAttributeArray = (
  state: IRootState,
  ids: string[],
  attribute: string
) => ids.map(id => selectMemberAttribute(state, id, attribute)) as string[];

/* ***** *****  Profile selector  ***** ***** */

export const selectMemberProfileData = (
  state: IRootState,
  id: IMember['id'],
  attribute: string
) => {
  const member = selectMember()(state, id);

  return get(member, `profile.${attribute}`);
};

export const selectMemberHasPrivatePicture = (
  state: IRootState,
  id: IMember['id']
): boolean | undefined => {
  const member = selectMember()(state, id);
  const isPrivate = get(member, 'attributes.privacy.privatePicture');
  const isReveal = get(member, 'profile.photoRevealStatus') === 'accepted';

  return isPrivate && !isReveal;
};

export const selectMemberHasPrivatePictureArray = (
  state: IRootState,
  ids: string[]
) => ids.map(id => selectMemberHasPrivatePicture(state, id));

export const selectMemberInstance = selectMember();
